// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MCtW","name":"Header_name__3yGX1","birthday":"Header_birthday__3_S2P","skeleton":"Header_skeleton__B1AVJ"};